import {useLazyQuery} from "react-apollo";

import getOrCreateChatGroupQuery from "../../../../shared/Inbox/queries/getOrCreateChatGroupQuery";

export function useGetOrCreateChatGroup() {
    const [getOrCreateChatGroup, {data: chatGroupData}] = useLazyQuery(getOrCreateChatGroupQuery);

    return {
        getOrCreateChatGroup,
        chatGroupData,
    };
}
